import React from "react";

export default () => (
    <React.Fragment>
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify(
                    {
                        "@context": "http://schema.org",
                        "@type": "HotelRoom",
                        "name": "Premier Room",
                        "url": "https://www.hoteltwintowers.com/hotel-room-in-shimla/premier-room",
                        "image": "https://www.hoteltwintowers.com/images/premier-banner.png",
                        "description": "These best premier rooms in Kufri are spacious measuring in at 380 square feet. They come with a king-sized bed and breath-taking views of the surrounding valley. This room has a desk with an elegant design, an electric safe, free Wi-Fi, a sitting area, a hardwood floor, a closet, and other storage space.",
                        "containedInPlace": {
                            "@type": "Place",
                            "name": "The Twin Towers Hotel",
                            "url": "https://www.hoteltwintowers.com/",
                            "hasMap": "https://goo.gl/maps/GzserDhdgJJFburx5",
                            "address": {
                                "@type": "PostalAddress",
                                "streetAddress": "NH 05, New kufri, Galu, Hills,",
                                "addressLocality": "Shimla",
                                "addressRegion": "Indian Himalayan Region",
                                "postalCode": "171209",
                                "addressCountry": "India"
                            }
                        },
                        "bed": {
                            "@type": "BedDetails",
                            "numberOfBeds": 2
                        },
                        "occupancy": {
                            "@type": "QuantitativeValue",
                            "maxValue": "2"
                        },
                        "amenityFeature": [
                            {
                                "@type": "LocationFeatureSpecification", "value": "True", "name": "City Views"
                            },
                            { "@type": "LocationFeatureSpecification", "value": "True", "name": "Balcony" },
                            { "@type": "LocationFeatureSpecification", "value": "True", "name": "King Size Bed" }
                        ]
                    }
                )
            }}
        />
    </React.Fragment>
);
